/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
*  Copyright © 2025 Pearson Education, Inc.
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Pearson Education, Inc.  The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
* patent applications, and are protected by trade secret or copyright law.
* Dissemination of this information, reproduction of this material, and copying or distribution of this software
* is strictly forbidden unless prior written permission is obtained
* from Pearson Education, Inc.
* */



import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
/**
 * Expanded Hover Icon Component
 * 
 **/
const ExpandedHoverIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 12"
      style={{
        width: '16px',
        height: '12px',
        flexShrink: 0,
        ...props.style
      }}
    >
      {/* Left side hover fill - initially transparent */}
      <rect
        x="0"
        y="0"
        width="6"
        height="12"
        rx="4"
        fill="transparent"
        stroke="transparent"
        strokeWidth="1"
        className="left-hover-fill"
      />

      {/* Main icon path */}
      <path
        d="M8.82051 6.49837H12.5031C12.6398 6.49837 12.757 6.44951 12.8547 6.35179C12.9524 6.25407 13.0012 6.13681 13.0012 6C13.0012 5.86319 12.9524 5.74593 12.8547 5.64821C12.757 5.55049 12.6398 5.50163 12.5031 5.50163H8.82051L9.81685 4.62215C9.92104 4.53094 9.97965 4.41694 9.99267 4.28013C9.99919 4.14332 9.95686 4.0228 9.86569 3.91857C9.77452 3.81433 9.66056 3.75896 9.52381 3.75244C9.38706 3.74593 9.26659 3.78502 9.16239 3.86971L7.15995 5.61889C7.04925 5.71661 6.9939 5.84365 6.9939 6C6.9939 6.14984 7.04925 6.27687 7.15995 6.38111L9.16239 8.13029C9.26659 8.2215 9.38706 8.26059 9.52381 8.24756C9.66056 8.24104 9.77452 8.18567 9.86569 8.08143C9.95686 7.9772 9.99919 7.85668 9.99267 7.71987C9.98616 7.58306 9.92755 7.46906 9.81685 7.37785L8.82051 6.49837ZM2.00244 0C1.44892 0 0.976801 0.19544 0.586081 0.586319C0.19536 0.977199 0 1.44625 0 1.99349V10.0065C0 10.5603 0.19536 11.0293 0.586081 11.4137C0.976801 11.8046 1.44892 12 2.00244 12H13.9976C14.5511 12 15.0232 11.8046 15.4139 11.4137C15.8046 11.0228 16 10.5537 16 10.0065V1.99349C16 1.43974 15.8046 0.970684 15.4139 0.586319C15.0232 0.19544 14.5511 0 13.9976 0H2.00244ZM0.996337 1.99349C0.996337 1.71987 1.09402 1.48534 1.28938 1.2899C1.48474 1.09446 1.72243 0.996743 2.00244 0.996743H5.00122V11.0033H2.00244C1.72894 11.0033 1.49125 10.9055 1.28938 10.7101C1.09402 10.5147 0.996337 10.2801 0.996337 10.0065V1.99349ZM5.99756 11.0033V0.996743H13.9976C14.2711 0.996743 14.5088 1.09446 14.7106 1.2899C14.906 1.48534 15.0037 1.71987 15.0037 1.99349V10.0065C15.0037 10.2801 14.906 10.5147 14.7106 10.7101C14.5153 10.9055 14.2776 11.0033 13.9976 11.0033H5.99756Z"
        fill="#FEFEFE"
      />
    </SvgIcon>
  );
};
export default ExpandedHoverIcon;
